const translations = {
    unknownApi: 'We received an unexpected error from the API'
};

export default translations;
